module.exports = __webpack_public_path__ + "img/graph-intro.410a748a.svg";